export enum OrderType {
  DESCEND = 'descend',
  ASCEND = 'ascend'
}
